package com.arenaproplay.admin.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.arenaproplay.admin.navigation.Routes
import com.arenaproplay.admin.ui.utils.encodeQueryValue
import com.arenaproplay.admin.ui.utils.urlParam

/**
 * Legacy /behavior route — redirects to /analytics?tab=behavior.
 *
 * Content has fully moved to the «Поведение» tab of AnalyticsPage (R6).
 * This stub keeps old bookmarks/external links working.
 */
@Page("/behavior")
@Composable
fun BehaviorPage() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        val period = urlParam("period")?.let { "&period=${encodeQueryValue(it)}" } ?: ""
        ctx.router.navigateTo("${Routes.ANALYTICS}?tab=behavior$period")
    }
}
